
<template>
  <div>
    <h2>Neue Maßnahme</h2>
    <p>
      Die Hilfe beinhaltet nützliche Information über Eingabe, Berechnung und
      Grundlagen der Maßnahmen.
    </p>
    <p>Die Eingabe erfolgt über Eingabefelder oder Menüoptionen.<br /></p>

    <table>
      <thead>
        <tr>
          <th>Parameter</th>
          <th>Beschreibung</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Methode</td>
          <td>Methode der Maßnahme oder Anglagenart</td>
        </tr>
        <tr>
          <td>Maßnahmen Name</td>
          <td>Name einzelner Maßnahmen</td>
        </tr>
        <tr>
          <td>Gruppe</td>
          <td>
            Hinzufügen zu einer Gruppierung mehrerer Maßnahmen
            <!-- ✅ Guarded link: only render if projectId exists -->
            <router-link
              v-if="projectId"
              :to="{ name: 'ProjectDashboard', params: { projectId: String(projectId) } }"
            >
              Neue Gruppe erstellen.
            </router-link>
            <!-- Fallback when no project is selected -->
            <router-link v-else :to="{ name: 'ProjectList' }" class="text-disabled">
              Neue Gruppe erstellen (Projekt wählen)
            </router-link>
          </td>
        </tr>
      </tbody>
    </table>

    <p>
      Maßnahmen können mit der überschlägigen oder der genormten /
      wissenschaftlichen Methode berechnet werden. Die überschlägigen Methoden
      benötigen weniger Daten und sind somit schneller zu untersuchen. Die
      genormten / wissenschaftlichen Methoden bieten auf der anderen Seite eine
      zuverlässige Berechnung welche belastbar sind.
    </p>

    <p>Folgende Punkte sind zu beachten:</p>
    <dl>
      <dt><strong>Überschlägige Methoden:</strong></dt>
      <ul>
        <li>
          Ziel ist es, mit geringem Aufwand für Begehung und Datenaufnahme einen
          Überblick über die vorhandenen Energieeinsparpotentiale einer
          Liegenschaft zu erhalten. Es wird für die Berechnung dieser Methode,
          aufgrund der geringen Anzahl an Parametern ist mit einer Genauigkeit
          von +- 15% zurechnen.
        </li>
        <li>
          Bei der Verwendung dieser Methode sollte beachtet werden, dass die
          Anlagenparameter stark vereinfacht sind. Deshalb wird bei einer
          ungewöhnlich niedrigen oder hohen Einsparung empfohlen Ihre Maßnahme
          mit der ausführlichen Methode gegenzurechnen.
        </li>
      </ul>
      <dt><strong>Detaillierte Methoden:</strong></dt>
      <ul>
        <li>
          Ziel ist es, mit einer detaillierten Begehung und Datenaufnahme eine
          genaue Berechnung der vorhandenen Energieeinsparpotentiale einer
          Liegenschaft zu erhalten.
        </li>
        <li>
          Werden vom Kunden im Rahmen der Potentialanalyse keine detailliertere
          Angaben geliefert, so wird die überschlägige Methode für die
          Durchführung der Potentialanalyse empfohlen.
        </li>
      </ul>
    </dl>

  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useProjectStore } from '@/stores/projectStore';

// Get projectId from the store; guard against null
const store = useProjectStore();
const projectId = computed(() => store.currentProject?.id ?? null);
</script>

<style scoped>
/* Optional: dim the fallback link */
.text-disabled {
  opacity: 0.7;
  pointer-events: auto; /* keep clickable to ProjectList */
}
</style>
